export enum DropdownMenuLabelMode {
    StaticLabel = 'static-label',
    SelectedValue = 'selected-value'
}
